import type { WorksheetModule } from "@arbeidsark/shared"
import { getAuthToken } from "~/modules/authentication"
import { API_URL } from "~/utils/env"
import {
  captureWorksheetDownload,
  type WorksheetAnalyticsProperties,
} from "./analytics"

export async function downloadWorksheet(
  id: number,
  name: string,
  analyticsProperties: WorksheetAnalyticsProperties = {},
) {
  const loginToken = getAuthToken()

  const response = await fetch(`${API_URL}/rest/worksheets/download/${id}`, {
    headers: {
      Authorization: `Bearer ${loginToken}`,
    },
  })

  const blob = await response.blob()
  const blobURL = URL.createObjectURL(blob)
  const downloadElement = document.createElement("a")
  downloadElement.href = blobURL
  downloadElement.download = name || ""
  document.body.appendChild(downloadElement)
  downloadElement.click()
  captureWorksheetDownload({
    ...analyticsProperties,
    worksheet_id: id,
  })
  document.body.removeChild(downloadElement)
}

export async function printPDF(id: number): Promise<void> {
  const authToken = getAuthToken()
  const url = `${API_URL}/rest/worksheets/print/${id}?token=${authToken}`

  // Create new tab and navigate to the url
  window.open(url, "_blank")
}

export function normalizePreviewPages(
  pages: ReadonlyArray<ReadonlyArray<Partial<WorksheetModule>>>,
): WorksheetModule[][] {
  return pages.map(
    (page) =>
      page.map((module) => ({
        ...module,
        size: module.size ?? "full",
        type: module.type ?? null,
      })) as WorksheetModule[],
  )
}
